module.exports = __webpack_public_path__ + "6427d29ad0b69212d5ae6b3b7992a4f0.svg";